import { combineReducers } from 'redux'

export const makeRootReducer = () =>
  combineReducers({
    domex: require('../Redux/DomexRedux').reducer,
    general: require('../Redux/GeneralRedux').reducer,
    navigation: require('../Redux/NavigationRedux').reducer,
  })

export default makeRootReducer
